import React from "react";
import HeroSection from "../components/HeroSection";
import { heroSections } from "../constants/data.ts";

const Blog = () => {
  return (
    <main className="bg-background">
      <HeroSection {...heroSections.blog} />

      <section className="py-16 md:py-24 px-outer">
        <div className="container mx-auto max-w-4xl space-y-10">
          <article className="card p-8">
            <h2 className="heading mb-3">
              Digital transformation for growing businesses
            </h2>
            <p className="text-body">
              How modern enterprises can adopt digital-first strategies to
              improve customer experience and operational agility.
            </p>
          </article>
          <article className="card p-8">
            <h2 className="heading mb-3">
              Why staffing technology matters in 2026
            </h2>
            <p className="text-body">
              A look at staff automation, talent pipelines, and the tools that
              make hiring faster and smarter.
            </p>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Blog;
